<ngx-doc-viewer
    [url]="fileUrl.changingThisBreaksApplicationSecurity"
    viewer="url"
    style="width: 100%; height: 100vh"></ngx-doc-viewer>
